import React, { useContext, useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Spinner,
  Button,
  Form,
} from "react-bootstrap";
import MasterLayout from "../master/MasterLayout";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { scrollToTop } from "../../../helper/HelperFunctions";
import { withSwal } from "react-sweetalert2";
import AppContext from "../../../context/AppContext";

const ManageCategory = ({ swal }) => {
  const navigate = useNavigate();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const { baseUrl } = useContext(AppContext);
  const [accessToken, setAccessToken] = useState("");
  const [loading, setLoading] = useState(true);
  const [addCategoryLoading, setAddCategoryLoading] = useState(false);
  const [deleteCategoryLoading, setDeleteCategoryLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState("");

  const getAllCategories = (accessToken) => {
    console.log(accessToken);
    axios
      .get(`${baseUrl}/api/category/getCategoriesForAdmin`, {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((resp) => {
        console.log(resp.data);
        setCategories(resp.data.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const addCategory = () => {
    const formData = new FormData();
    formData.append("name", `${categoryName}`);
    formData.append("image", categoryImage);

    axios
      .post(`${baseUrl}/api/category/addCategory`, formData, {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setCategoryName("");
        setAddCategoryLoading(false);
        if (response.data.success == "yes") {
          swal.fire({
            title: "Welldone!",
            text: "Another Category Added to Shop.",
            icon: "success",
          });

          getAllCategories(accessToken);
        } else {
          swal.fire({
            title: "Sorry!",
            text: "Unable to add another Category.",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        setAddCategoryLoading(false);
        // setErrorMessages(err.response.data.error);
        // setLoading(false);
      });
  };

  const deleteCategory = (category_id) => {
    const formData = new FormData();
    formData.append("category_id", `${category_id}`);

    axios
      .post(`${baseUrl}/api/category/deleteCategory`, formData, {
        headers: {
          Authorization: "Bearer " + accessToken,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response);
        console.log(response.data);
        setDeleteCategoryLoading(false);
        if (response.data.success == "yes") {
          swal.fire({
            title: "Welldone!",
            text: "Category Deleted From Shop.",
            icon: "success",
          });

          getAllCategories(accessToken);
        } else {
          swal.fire({
            title: "Sorry!",
            text: "Unable to Delete Category.",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        setAddCategoryLoading(false);
        // setErrorMessages(err.response.data.error);
        // setLoading(false);
      });
  };

  useEffect(() => {
    scrollToTop();
    setTimeout(() => {
      if (localStorage.getItem("admin") == null) {
        navigate("/");
      } else {
        const admin = JSON.parse(localStorage.getItem("admin"));
        setAccessToken(admin.access_token);
        getAllCategories(admin.access_token);
        setLoading(false);
      }
    }, 1000);
  }, []);

  return loading ? (
    <Row className="d-flex justify-content-lg-center">
      <Spinner style={{ width: "50px", height: "50px", marginTop: "20%" }} />
    </Row>
  ) : (
    <MasterLayout>
      <Container fluid className="m-0 p-0">
        <h3 className="poppins-semiBold">Add Categories</h3>
        <Row className="g-3 my-3">
          <Col xs={12} md={3} className="my-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label className="poppins-bold">Category Name</Form.Label>
              <input
                className="poppins-regular form-control"
                type="text"
                placeholder="Category Name"
                size="lg"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                required
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3} className="my-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label className="poppins-bold">Category Image</Form.Label>
              <input
                className="poppins-regular form-control"
                type="file"
                size="lg"
                onChange={(e) => {
                  console.log(e.target.files[0]);
                  setCategoryImage(e.target.files[0]);
                }}
                required
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={3} className="my-3">
            <Form.Group controlId="exampleForm.ControlInput1">
              <Form.Label className="poppins-bold">Action</Form.Label>
              <br />
              {addCategoryLoading ? (
                <Spinner size={"sm"} color="#000" />
              ) : (
                <button
                  onClick={() => {
                    if (categoryName == "") {
                      swal.fire({
                        title: "Important!",
                        text: "Category name is required.",
                        icon: "error",
                      });
                    } else {
                      setAddCategoryLoading(true);
                      addCategory();
                    }
                  }}
                  className="btn btn-md btn-success poppins-bold"
                >
                  Add Category
                </button>
              )}
            </Form.Group>
          </Col>
        </Row>
        <h3 className="poppins-semiBold">Available Categories</h3>
        <Table
          responsive
          bordered
          striped
          // hover
          // variant="primary"
          // variant="light"
          size={isDesktopOrLaptop ? "lg" : "sm"}
          className=" my-4  "
        >
          <thead>
            <tr>
              <th className="poppins-semiBold">#</th>
              <th className="poppins-semiBold">Category Name</th>
              <th className="poppins-semiBold">Image</th>
              <th className="poppins-semiBold">Action</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((item, index) => (
              <tr key={index} className="res-small-text">
                <td className="poppins-regular">{index + 1}</td>
                <td className="poppins-regular ">{item.name}</td>
                <td className="poppins-regular">
                  <a target="_blank" href={`${baseUrl}/storage/${item.image}`}>
                    <img
                      style={{ height: 50, width: 50, borderRadius: 100 }}
                      src={`${baseUrl}/storage/${item.image}`}
                    />
                  </a>
                </td>
                <td className="poppins-regular">
                  {deleteCategoryLoading ? (
                    <Spinner size="sm" color="#000" />
                  ) : (
                    <Button
                      variant="danger"
                      className="poppins-semiBold txt-white"
                      onClick={() => {
                        setDeleteCategoryLoading(true);
                        deleteCategory(item.id);
                      }}
                    >
                      DELETE
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>
    </MasterLayout>
  );
};

export default withSwal(ManageCategory);
